export default __webpack_public_path__ + "static/media/logoApp.3dfa67a1.png";